import { combineReducers } from "redux"
import {
    AppInstanceReducer,
    AppInstanceState,
    AppInstanceAction
} from "./AppInstance/AppInstanceReducer"
import { JobReducer, JobState, JobAction } from "./Job/JobReducer"
import {
    APIAuthenticationReducer,
    APIAuthenticationState,
    APIAuthenticationAction
} from "./AuthenticationReducer"
import {
    AppTemplateReducer,
    AppTemplateState,
    AppTemplateAction
} from "./AppTemplate/AppTemplateReducer"
import {
    TemplateInstantiateReducer,
    TemplateInstantiateState,
    TemplateInstantiateAction
} from "./AppTemplate/Interface/TemplateInstantiateReducer"
import {
    BillingReducer,
    BillingState,
    BillingAction
} from "./Billing/BillingReducer"
import {
    AppInstanceBaselineDataReducer,
    AppInstanceBaselineDataState,
    AppInstanceBaselineDataAction
} from "./AppInstance/AppInstanceBaselineDataReducer"
import {
    AppInstanceCustomizeReducer,
    AppInstanceCustomizeState,
    AppInstanceCustomizeAction
} from "./AppInstance/AppInstanceCustomizeReducer"
import {
    VisualEditorAction,
    VisualEditorReducer,
    VisualEditorState
} from "./VisualEditorReducer"
import {
    JobsDownloadReducer,
    JobsDownloadState,
    JobsDownloadAction
} from "./Job/JobsDownloadReducer"
import { DataReducer, DataAction, DataState } from "./Data/DataReducer"
import {
    CollaboratorReducer,
    CollaboratorState,
    CollaboratorAction
} from "./Collaborator/CollaboratorReducer"
import { MetricsState, MetricsAction, MetricsReducer } from "./Metrics/Metrics"
import {
    AppTemplateAvailabilityState,
    AppTemplateAvailabilityAction,
    AppTemplateAvailabilityReducer
} from "./AppTemplate/AppTemplateAvailablityReducer"
import { TaskAction, TaskReducer, TaskState } from "./Task/TaskReducer"
import {
    OrgMemberState,
    OrgMemberAction,
    OrgMemberReducer
} from "./Org/OrgMemberReducer"
import { WorkerAction, WorkerReducer, WorkerState } from "./WorkerReducer"
import {
    WorkerGroupAction,
    WorkerGroupReducer,
    WorkerGroupState
} from "./WorkerGroupReducer"
import { HeroAction, HeroReducer, HeroState } from "./HeroReducer"
import {
    BackofficeReducer,
    BackofficeAction,
    BackofficeState
} from "./Backoffice/BackofficeReducer"
import {
    MarketplaceAppAction,
    MarketplaceAppReducer,
    MarketplaceAppState
} from "./Marketplace/MarketplaceAppReducer"
import {
    SuperTasksAction,
    SuperTasksReducer,
    SuperTasksState
} from "./SuperTasksReducer"
import { InboxAction, InboxReducer, InboxState } from "./Inbox/InboxReducer"
import {
    StatisticsAction,
    StatisticsReducer,
    StatisticsState
} from "./Statistics/StatisticsReducer"

export const APIReducer = combineReducers({
    apps: AppInstanceReducer,
    appCustomize: AppInstanceCustomizeReducer,
    baselineData: AppInstanceBaselineDataReducer,
    jobs: JobReducer,
    downloadJobs: JobsDownloadReducer,
    templates: AppTemplateReducer,
    templateAvailability: AppTemplateAvailabilityReducer,
    authentication: APIAuthenticationReducer,
    billing: BillingReducer,
    data: DataReducer,
    collaborator: CollaboratorReducer,
    inbox: InboxReducer,
    interface: combineReducers({
        templateInstantiate: TemplateInstantiateReducer
    }),
    metrics: MetricsReducer,
    tasks: TaskReducer,
    orgs: OrgMemberReducer,
    workers: WorkerReducer,
    workerGroups: WorkerGroupReducer,
    heros: HeroReducer,
    backoffice: BackofficeReducer,
    marketplace: MarketplaceAppReducer,
    superTasks: SuperTasksReducer,
    statistics: StatisticsReducer,
    visualEditor: VisualEditorReducer
})

export interface APIState {
    apps: AppInstanceState
    appCustomize: AppInstanceCustomizeState
    baselineData: AppInstanceBaselineDataState
    jobs: JobState
    downloadJobs: JobsDownloadState
    templates: AppTemplateState
    templateAvailability: AppTemplateAvailabilityState
    authentication: APIAuthenticationState
    billing: BillingState
    data: DataState
    collaborator: CollaboratorState
    interface: {
        templateInstantiate: TemplateInstantiateState
    }
    metrics: MetricsState
    tasks: TaskState
    orgs: OrgMemberState
    workers: WorkerState
    workerGroups: WorkerGroupState
    heros: HeroState
    backoffice: BackofficeState
    marketplace: MarketplaceAppState
    superTasks: SuperTasksState
    visualEditor: VisualEditorState
    inbox: InboxState
    statistics: StatisticsState
}

export type APIAction =
    | AppInstanceAction
    | JobAction
    | APIAuthenticationAction
    | AppTemplateAction
    | AppTemplateAvailabilityAction
    | TemplateInstantiateAction
    | BillingAction
    | AppInstanceBaselineDataAction
    | AppInstanceCustomizeAction
    | JobsDownloadAction
    | DataAction
    | CollaboratorAction
    | MetricsAction
    | TaskAction
    | OrgMemberAction
    | WorkerAction
    | WorkerGroupAction
    | HeroAction
    | BackofficeAction
    | MarketplaceAppAction
    | SuperTasksAction
    | VisualEditorAction
    | InboxAction
    | StatisticsAction
